import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock, getOptionsCode } from '../Util'
import Mutators from '../Mutators'

const ftpOptionsMutator = 'sirenia_ftp_options_mutator'

Mutators.registerOptionsMutator(ftpOptionsMutator, {
  user: {},
  pass: {}
})

defineBlock(
  'sirenia_api_ftp_read',
  {
    message0: `data from ftp url %1`,
    args0: [
      {
        type: 'input_value',
        name: 'URL',
        check: 'String'
      }
    ],
    output: null,
    tooltip: `Read contents of file on an FTP server`,
    helpUrl: `http://sirenia.eu/product/configuration-interface/documentation/flows/#ftp`,
    mutator: ftpOptionsMutator
  },
  function(block) {
    const urlCode =
      Blockly.JavaScript.valueToCode(block, 'URL', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    const optionsObject = getOptionsCode(this.chosenProps, block)
    const code = `Ftp.read(${urlCode}, ${optionsObject})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_ftp_write',
  {
    message0: `write to ftp file %1 data %2`,
    args0: [
      {
        type: 'input_value',
        name: 'URL',
        check: 'String'
      },
      {
        type: 'input_value',
        name: 'DATA',
        check: 'String',
        align: 'RIGHT'
      }
    ],
    mutator: ftpOptionsMutator,
    tooltip: `Write data to a file on an FTP server`,
    helpUrl: `http://sirenia.eu/product/configuration-interface/documentation/flows/#ftp`
  },
  function(block) {
    const valueCode =
      Blockly.JavaScript.valueToCode(block, 'DATA', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    const urlCode =
      Blockly.JavaScript.valueToCode(block, 'URL', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    const optionsObject = getOptionsCode(this.chosenProps, block)
    return `Ftp.write(${urlCode}, ${valueCode}, ${optionsObject});\n`
  }
)
